import { pick } from 'lodash';

const INITIAL_STATE = {
	make: "",
	model: "",
	year: "",
	trim: "",
	color: "",
	plate: "",
	VIN: "",
	starting_odometer: ""
}

export default (state=INITIAL_STATE, action) => {
	let newState = {...state};
	switch(action.type){
		case "NEW_VEHICLE":
			return Object.assign(
				newState,
				pick(action,Object.keys(newState))
			)

		default:
			return newState
	}
}


// WEBPACK FOOTER //
// ./src/reducers/details.js